import { CircularProgress, styled } from '@mui/material';

import { getThemeColor, TMoplaColors } from '@mopla/mui';

interface IStyledCircularProgressProps {
	loaderColor: TMoplaColors;
}

export const StyledCircularProgress = styled(CircularProgress, {
	shouldForwardProp: (prop) => prop !== 'loaderColor',
})<IStyledCircularProgressProps>(({ theme, loaderColor }) => ({
	color: getThemeColor(loaderColor, theme),
}));
